import { IGenieInit } from "store/genie/types";
import { GenieActionKeys } from "store/genie/keys";


export function init(): IGenieInit {
    return {
        type: GenieActionKeys.INIT
    }
}
